// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"458":"8cd1d5f0","459":"f856fef6","774":"140fe2d4","787":"132878fd","858":"ce8a053c","916":"6e0d245b"}[chunkId] + ".chunk.js";
};